import { useContext, useEffect } from "react";
import { Button } from "@material-ui/core";
import { withUbdAnalyticsStep } from "@aspirasi/react-data-analytics";
import { StoreContext } from "../../../store/context";
import Header from "../../../components/Header";
import Footer from "../../../components/Footer";

import { useThemeStyles } from "../../../styles/themes";
import "./ConsentFailed.scss";
import clevertapWebview from "../../../utils/clevertap";
import { EVENT_NAME } from "../../../constants/clevertap";

const ConsentFailed = () => {
  const classes = useThemeStyles();
  const { state, actions } = useContext(StoreContext);

  const content = {
    title: "Oops!",
    message: "We're unable to switch your financing to \u003Cb\u003EBoost Bank\u003C/b\u003E at this time. Your financing will remain with \u003Cb\u003EBoost Credit\u003C/b\u003E and stays Shariah-compliant."
  };

  const redirectDashboard = (type) => {
    if (type === "new") {
      actions.getDashboardUrl().then((res) => {
        if (res.data?.redirectionUrl) {
          window.location.href = res.data?.redirectionUrl;
        }
      });
      return;
    }

    if (state.dashboardUrl) {
      window.location.href = state.dashboardUrl;
    } else {
      window.location.href = process.env.REACT_APP_BNPL_DASHBOARD_URL;
    }
  };

  useEffect(() => {
    clevertapWebview.pushEvent(EVENT_NAME.OUTCOME_BNPL_REG_SUCCESS, { SOURCE: "main" });
  }, []);

  return (
    state.prerequisites
    && (
      <>
        <Header />
        <div className="page page-consent-failed ">
          <div
            className={`${classes.content} ${classes.customScrollbar} content custom-scrollbar`}
            style={{ display: "flex", flexDirection: "column" }}
          >
            <div style={{ flex: 1, display: "flex", flexDirection: "column", justifyContent: "center", alignItems: "center" }}>
              <img
                className="banner"
                src="/images/failure-cross.png"
                alt="failure"
              />
              <p className="failure-title">
                {content.title}
              </p>
              <p
                className="failure-sub-title"
                dangerouslySetInnerHTML={{
                  __html: content.message
                }}
              />
            </div>

            <div className="action-holder" style={{ display: "flex", flexDirection: "column", gap: "10px", }}>

              {state.isOnboardingUpdate && (
                <Button className={`${classes.btnContained} btn-next`} variant="contained" color="primary" onClick={() => redirectDashboard("new")}>
                  Done
                </Button>
              )}

            </div>

          </div>
          <Footer />
        </div>
      </>
    )
  );
};

export default withUbdAnalyticsStep(ConsentFailed, {
  stepId: "ConsentFailed",
  endJourneyOnStepStart: true,
});
